import React, { Component } from 'react'
import { isEmpty } from 'lodash/fp'
import snakeCase from 'snake-case'
import { navigateTo } from 'gatsby-link'
import { getRoomQuizQA, isLastRoom, selectRandomRoom } from '../helpers'
import Tip from '../components/Tip'

export default class RoomPageBase extends Component {
  componentDidMount() {
    if (isEmpty(this.props.firstName)) navigateTo('/age/')
  }

  onItemClick(id) {
    this.props.clickItem(`${this.constructor.roomId}__${id}`)
    this.props.transition(snakeCase(id).toUpperCase())
  }

  getTip(id) {
    const { data } = this.props

    if (!data) return false

    const { edges } = data.allMarkdownRemark
    const edge = edges.find((edge) => edge.node.frontmatter.id === id)

    return edge && edge.node
  }

  getOpenedTipsCount() {
    const { clickedItems } = this.props

    const filteredClickedItems = clickedItems.filter(
      (item) =>
        item.startsWith(this.constructor.roomId) + '__' &&
        this.constructor.validItems
          .map((item) => `${this.constructor.roomId}__${item}`)
          .includes(item),
    )

    return filteredClickedItems.length
  }

  getPendingHighlightIds() {
    return []
  }

  getSuccessHighlightIds() {
    return []
  }

  getClickedItemsForRoom() {
    const { roomId, validItems } = this.constructor

    return this.props.clickedItems
      .filter((item) => item.startsWith(roomId))
      .map((item) => item.substr(roomId.length + 2))
      .filter((item) => validItems.includes(item))
  }

  clickedAllItems() {
    return this.getOpenedTipsCount() >= this.constructor.validItems.length
  }

  onRoomClear(
    event,
    {
      roomId,
      roomsCleared,
      gameFinished,
      setRoomsCleared,
      setModalStatus,
      setGameFinished,
      setSelectedRoom,
      setStartButtonUrl,
      clearedQuizRoomIds,
      openQuizModal,
    },
  ) {
    event.preventDefault()
    const hasClearedRoom = roomsCleared.includes(roomId)
    const hasClearedQuiz = clearedQuizRoomIds.includes(roomId)

    if (gameFinished) {
      setModalStatus(false)
      return navigateTo('/aloha')
    }

    if (!hasClearedQuiz) {
      return openQuizModal(getRoomQuizQA(roomId))
    }

    if (!hasClearedRoom) {
      setRoomsCleared([...roomsCleared, roomId])
    }

    if (isLastRoom(roomsCleared, roomId)) {
      setGameFinished(true)
      setModalStatus(false)

      return navigateTo('/aloha')
    }

    selectRandomRoom(
      [...roomsCleared, roomId],
      setSelectedRoom,
      setStartButtonUrl,
    )
    setModalStatus(true)
  }

  renderTip(id, props = {}) {
    const { transition } = this.props

    const tip = this.getTip(id)
    if (!tip) return

    const {
      html,
      frontmatter: { title },
    } = tip

    return (
      <Tip
        character="pluggy"
        closable={true}
        close={(e) => {
          transition('NEXT')
          if (props.onClose) {
            props.onClose(e)
          }
        }}
        heading={title}
        {...props}
      >
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </Tip>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RoomPageBase.js